<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_1_' + this.id]">
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h1 class="mt-10 mb-2">Bienvenue dans la Troposphère.</h1>
          <p class="mt-2 mb-2">
            Pour l’arpenter en toute sécurité,
            <strong>tu dois créer une ancre dans la réalité physique</strong>, pour ne pas te perdre dans cet univers
            non tangible. Plus cette ancre résonne avec la porte (ton point d’accès), plus elle sera efficace. Comme
            ancre, nous te proposons d'utiliser ton foulard. À quoi ressemble-t-il ?
          </p>
          <div>
            <h2>Couleur du fond:</h2>
            <ul class="color-list">
              <li class="color-item" v-for="color in colorsPossible" :key="color">
                <div
                  v-if="color != selectedColorFond"
                  @click="changeColor(color, 'fond')"
                  :style="`background-color: ${color};`"
                  class="selectableColor"
                ></div>
                <div v-else :style="`background-color: ${color};`" class="selectedColor"></div>
              </li>
            </ul>
          </div>
          <div>
            <h2>Couleur du liseré:</h2>
            <ul class="color-list">
              <li class="color-item" v-for="color in colorsPossible" :key="color">
                <div
                  v-if="color != selectedColorLisere"
                  @click="changeColor(color, 'lisere')"
                  :style="`background-color: ${color};`"
                  class="selectableColor"
                ></div>
                <div v-else :style="`background-color: ${color};`" class="selectedColor"></div>
              </li>
            </ul>
          </div>
          <div>
            <h2>Couleur de la bague:</h2>
            <ul class="color-list">
              <li class="color-item" v-for="color in colorsPossible" :key="color">
                <div
                  v-if="color != selectedColorBague"
                  @click="changeColor(color, 'bague')"
                  :style="`background-color: ${color};`"
                  class="selectableColor"
                ></div>
                <div v-else :style="`background-color: ${color};`" class="selectedColor"></div>
              </li>
            </ul>
          </div>

          <div class="w-100" style="text-align: center;">
            <NextBtn @click="submit" :url="'/immersion01/' + (this.id + 1) + '?id='" text="Créer mon ancre" />
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <Foulard class="foulard" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.title {
  margin-top: 100px;
}
p {
  font-size: 24px;
}

.foulard {
  margin-top: 100px;
  height: 70vh;
}
.color-item {
  position: relative;
  width: 24px;
  height: 24px;
  margin: 10px 0 0 10px;
  display: inline-block;
}
.selectableColor {
  width: 100%;
  height: 100%;
}
.selectedColor {
  width: 100%;
  height: 100%;
  border-style: solid;
  border-width: 3px;
}
.send {
  position: absolute;
  width: 400px;
  bottom: 5%;
  left: 30%;
}
</style>

<script>
// @ is an alias to /src
import Foulard from "@/components/foulard.svg";
import ApiService from "@/services/ApiService";
import NextBtn from "@/components/NextButton";

export default {
  name: "IM_1_1",
  components: {
    Foulard,
    NextBtn
  },
  data: function () {
    return {
      selectedColorFond: "#ffffff",
      selectedColorLisere: "#ffffff",
      selectedColorBague: "#ffffff",
      id: 1,
      colorsPossible: [
        "#eecea1",
        "#fbdae3",
        "#cd8c31",
        "#5E2A57",
        "#ed4630",
        "#CCCCCC",
        "#4c2b11",
        "#f49c31",
        "#fdf734",
        "#fffab2",
        "#204a1e",
        "#48a37e",
        "#061d72",
        "#224afb",
        "#b2e8fd",
        "#ffffff",
        "#000000",
        "rgba(0,0,0,0)"
      ]
    };
  },
  methods: {
    submit: async function () {
      const resp = await ApiService.post("/scarfs/", {
        border_color: this.selectedColorLisere,
        background_color: this.selectedColorFond,
        knot_color: this.selectedColorBague
      });
      let id = resp.data.scarf.id;
      localStorage.setItem("scarf_id", id);
      this.$router
        .push({
          path: "/immersion01/" + (this.id + 1),
          query: { id: id }
        })
        .catch(() => {});
    },
    changeColor: function (color, element) {
      if (element === "fond") {
        let fond = document.getElementById("fond-foulard");
        this.selectedColorFond = color;
        fond.setAttribute("fill", color);
      } else if (element === "lisere") {
        let lisere = document.getElementById("lisere-foulard");
        this.selectedColorLisere = color;
        lisere.setAttribute("fill", color);
      } else if (element === "bague") {
        let bague = document.getElementById("bague-foulard");
        bague.setAttribute("fill", color);
        this.selectedColorBague = color;
      }
    }
  }
};
</script>
